<template>
  <div class="main-container">
    <div class="header-wrapper">
      <h3>吊车管理后台</h3>
    </div>

    <div class="content-wrapper">
      <div class="navigation-wrapper">
        <Tabs :value="activeRoute" type="card" @on-click="changeRouter">
          <TabPane label="审批" name="index"></TabPane>
          <TabPane label="吊车管理" name="car"></TabPane>
        </Tabs>
      </div>

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.activeRoute = this.$route.name.split('.').shift();
  },
  data() {
    return {
      activeRoute: 'index'
    }
  },
  methods: {
    changeRouter(routeName) {
      this.$router.push({name: routeName});
    }
  }
}
</script>

<style>
  .header-wrapper { height: 54px; line-height: 54px; background-color: #001429; padding: 0 24px; color: #fff; }
  .content-wrapper { margin: 24px 24px 0 24px; }
</style>
